export const ROUTE = {
  /* Guest */
  GUEST: '/guest',
  LOGIN: '/guest/login',
  FORGOT_PASSWORD: '/guest/forgotpassword',

  /* Dashboard */
  HOME: '/',
  CLASSES: '/classes/:type',
  INCOME: '/income',
  PROFILE: '/profile',
  NOTIFICATION: '/notification',
  MESSAGE: '/message/:group',
  CONVERSATION: '/conversation',
  UPDATE_PROFILE: '/update-profile',
  JOIN_MEETING: '/join-meeting',
  CONTRACTS: '/contracts',
  POLICIES: '/policies',
  REQUEST: '/request',

  /* Single Page */
  USER_AGENT: '/user-agent',
  CLASS_FEEDBACK: '/class-feedback/:meeting_id',
  FORCE_LOGIN: '/force-login/:authKey',
  CLASS_WAITING: '/class-waiting',
}
